import { format } from 'date-fns'
import { getLanguage } from "@/utils/locale";
import { ptBR, enUS, es } from 'date-fns/locale';

export function formatDateToString(date: Date | undefined, toFormat = 'MM/dd/yyyy') {
    const locale: string = getLanguage();
    if (locale === 'pt-BR' || locale === 'es-US') toFormat = 'dd/MM/yyyy';
    if (date) {
        return format(new Date(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate() + 1), toFormat);
    }
    return '-';
}

export function selectLocale(): Locale {
    const locale: string = getLanguage();
    if (locale === 'pt-BR') {
        return ptBR;
    } else if (locale === 'es-US') {
        return es;
    } else {
        return enUS;
    }
}